import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const StyledAmountLineLabel = styled(Typography)(
  ({ theme }) => ({
    color: '#444444',
    fontSize: '18px',
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      color: '#444444',
      fontSize: '18px',
      fontWeight: 700,
    },
  }),
);

export default StyledAmountLineLabel;
